import React from 'react';
import HolidaySale from '@hooks/useHolidaySale/HolidaySale';
import { FULL, MINI, AT_HOME } from '@constants/roomPackages';
import styles from './HolidaySaleCTA.module.scss';

interface IHolidaySaleProps {
  size: string;
  sale: HolidaySale;
  className?: string;
  isInsideContainer?: boolean;
}

export default function HolidaySaleCTA({ sale, className = '', isInsideContainer }: IHolidaySaleProps) {
  const fullDiscount = sale.roomPackageDiscount(FULL);
  const miniDiscount = sale.roomPackageDiscount(MINI);
  const inPersonDiscount = sale.roomPackageDiscount(AT_HOME);
  const discounts = [
    fullDiscount,
    miniDiscount,
    inPersonDiscount
  ].filter((d) => !!d);

  const primaryText = () => {
    if (inPersonDiscount?.discountText) {
      return inPersonDiscount.discountText;
    }
    if (fullDiscount?.discountText) {
      return fullDiscount.discountText;
    }
    if (miniDiscount?.discountText) {
      return miniDiscount.discountText;
    }

    return '';
  };

  const secondaryText = () => {
    if (inPersonDiscount) {
      return '';
    }
    if (fullDiscount) {
      return 'full designs';
    }
    return '';
  };

  if (!discounts.length) {
    return null;
  }

  return (
    // eslint-disable-next-line
    <a className={`${styles.CTACard} ${className} ${isInsideContainer ? styles.CardInsideContainer : ""}`} role="button" href="/#package-types">
      <div className={styles.Contents}>
        <div className={styles.ContentsWrapper}>
          <div className={styles.SaleText}>
            <span role="img" aria-hidden="true">{sale.emoji}</span> <span className={styles.SaleName}>{sale.name}</span>
          </div>
          <div className={styles.PrimaryText}>
            {primaryText()}
          </div>
          <div className={styles.SecondaryText}>
            {secondaryText()}
          </div>
          <div className={styles.CodeText}>
            USE CODE:&nbsp;
            <span className={styles.Code}>
              {fullDiscount?.code || miniDiscount?.code}
            </span>
          </div>
          <div className={styles.EndDate}>
            {sale.saleEndText}
          </div>
        </div>
        <div className={ styles.Overlay } />
      </div>
    </a>
  );
}
